import { Box, Flex } from '@chakra-ui/react'
import { GreyGrey30, GreyGrey50, Lato12Bold } from '@sequencehq/design-tokens'
import { format } from '@sequencehq/utils/dates'
import { timelineWeeksAtom } from '../atoms/timeline.atom'
import { useAtom } from 'jotai'
import { useTimelineDimensions } from '../hooks/useTimelineDimensions'
import { TIMELINE_AXIS_HEIGHT_PX } from '../timeline.constants'

const WeekIndicator = (props: {
  date: Date
  offset: number
  showLabel: boolean
}) => {
  return (
    <>
      <Flex
        position="absolute"
        left={`${props.offset - 6}px`}
        bottom="4px"
        width="12px"
        {...Lato12Bold}
        color={GreyGrey50}
        fontSize="10px"
        textTransform="uppercase"
        alignItems="center"
        justifyContent="center"
      >
        {props.showLabel && format(props.date, 'dd')}
      </Flex>
      <Box
        height="4px"
        width="1px"
        backgroundColor={GreyGrey30}
        position="absolute"
        bottom="0px"
        left={`${props.offset}px`}
      ></Box>
    </>
  )
}

export const ScheduleTimelineWeeks = () => {
  const [timelineWeeks] = useAtom(timelineWeeksAtom)
  const { timelineWidth } = useTimelineDimensions()

  return (
    <Box
      width={timelineWidth}
      borderBottom={`1px solid ${GreyGrey30}`}
      height={`24px`}
      pointerEvents="none"
    >
      {timelineWeeks.map(
        /**
         * The labels can get a bit smooshed at the beginning
         * of the timeline, so we ignore the very first. We also
         * only show the label every other week.
         */
        (week, idx) =>
          idx > 0 && (
            <WeekIndicator
              key={`week-${week.date.toString()}`}
              date={week.date}
              offset={week.offset}
              showLabel={!(idx % 2) && idx > 1}
            />
          )
      )}
    </Box>
  )
}
